import * as React from 'react';
import styled from 'styled-components';
import { ClearDiv } from '../../../common';

export interface IParticipationMonitorTableColumnProps {
	label?: string;
	fontSize?: 'xl';
	adjustLayoutForChart?: boolean;
}

const LabelPropertyWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`;

const Label = styled.span`
	font-weight: bold;
`;
Label.displayName = 'Label';

const Content = styled.div.attrs<{ fontSize?: 'xl' }>({})<{ fontSize?: 'xl' }>`
	font-size: ${(props) => (props.fontSize === 'xl' ? '14.5px' : '13px')};
	font-weight: 500;
	color: #444444;
`;
Content.displayName = 'Content';

export class ParticipationMonitorTableColumn extends React.PureComponent<React.PropsWithChildren<IParticipationMonitorTableColumnProps>> {
	public render() {
		return this.getLayout();
	}

	public getLayout() {
		if (this.props.adjustLayoutForChart) {
			return (
				<ClearDiv className='row' clearHeight={'0'}>
					<div className='col-lg-1 d-none d-lg-block' />
					<Content fontSize={this.props.fontSize} className='col-lg-10 col-sm-12'>
						{this.getContents()}
					</Content>
					<div className='col-lg-1 d-none d-lg-block' />
				</ClearDiv>
			);
		}
		return (
			<ClearDiv className='row' clearHeight={'0'}>
				<Content fontSize={this.props.fontSize} className='col-lg-12 col-sm-12'>
					{this.getContents()}
				</Content>
			</ClearDiv>
		);
	}

	public getContents() {
		if (this.props.label) {
			return (
				<LabelPropertyWrapper>
					<Label className='tws-label'>{this.props.label}</Label>
					<div>{this.props.children}</div>
				</LabelPropertyWrapper>
			);
		}
		return this.props.children;
	}
}
